import React, { useEffect } from 'react'
import Box from 'common/Box'
import useFormView from 'hooks/UseFormView'

const AccountForm = ({ fields, stateHandler, emitter }) => {
    const {
        validateInput,
        formView: {
            accountName,
            taxId,
        },
    } = useFormView(fields)

    useEffect(() => {
        const submitJointInput = () => {
            const { valid, input } = validateInput()
            if (valid) {
                stateHandler.account(input)
            } else {
                stateHandler.error(true)
            }
        }

        emitter.on('submitInput', submitJointInput)
        return () => emitter.removeListener('submitInput', submitJointInput)
    })

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            {accountName}
            {taxId}
        </Box>
    )
}

export default AccountForm
